module.exports = __webpack_public_path__ + "static/img/btbj_icon.png";